import React, { Component } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom';
import appConstant from '../../constants/app';
import InputComponent from '../components/baseComponents/input';
import myFiuLogo from '../../assets/images/my-fiu-logo.png'

class Login extends Component {
  state = {
    email: '',
    errorMessage: null,
    successMessage: null,
  }

  refFields = {}

  isValidForm = () =>
    Object.keys(this.refFields)
      .map(field => this.refFields[field] && this.refFields[field].validate())
      .reduce((sum, validField) => validField != null && sum + (!validField ? 1 : 0), 0) === 0;

  onFormSubmit = (e) => {
    const {
      email,
    } = this.state;

    this.setState({ errorMessage: ""})

    e.preventDefault() // Stop form submit

    if(!this.isValidForm()) return false;

    axios({
      method: 'post',
      url: `${appConstant.API_URL}/user/recover-password`,
      data: {
        email: email,
      },
    })
    .then(res => {
      this.setState({
        successMessage: "Your new password has been sent to your email",
        email: '',
      })
    }).catch(err => {
      this.setState({ errorMessage: "Email doesn't exist"})
    });
  }

  handleInputChange = (val, name) => {
    this.setState({[name]: val});
  }

  render () {
    const {
      email,
    } = this.state;

    return (
      <div>
        <div id="login">
          <img src={myFiuLogo} alt="My FIU" />
          <form onSubmit={this.onFormSubmit}>
            <fieldset>
              <p>
                <InputComponent
                  value={email}
                  ref={(input) => { this.refFields.email = input; }}
                  inputGroup="email"
                  validationRules="required|email"
                  customErrorMessage="Required field"
                  placeholder='Email'
                  classes='form-control'
                  onChange={this.handleInputChange}
                />
              </p>
              {this.state.errorMessage && <div className="error-message">{this.state.errorMessage}</div>}
              <p>
                <input type="submit" value="Reset password" />
              </p>
              {this.state.successMessage && <div style={{color: 'green'}}>{this.state.successMessage}</div>}
              <Link to="/login">Back to login</Link>
            </fieldset>
          </form>
        </div>
      </div>
    );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/app/screens/recoverPassword.js